import { CSSProperties } from 'react';

import Settings from '../../data/settings';

export interface DataLoaderProps {
  fullscreen?: boolean;
  overlay?: boolean;
  title?: string;
  dark?: boolean;
  style?: CSSProperties;
}

export default function DataLoader(props: DataLoaderProps) {
  const { fullscreen, overlay } = props;

  const title = props.title && props.title.length > 0 ? props.title : Settings.project.title;

  const sx: CSSProperties = { display: 'flex' }

  if (fullscreen) {
    sx.justifyContent = "center";
    sx.alignItems = "center";
    sx.width = "100%";
    sx.height = "100%";
  }

  if (overlay) {
    sx.backgroundColor = "rgba(255,255,255, 0.5)";
    sx.position = "absolute";
    sx.top = 0;
    sx.left = 0;
  }

  const { logo } = Settings.project;

  return (
    <div style={props.style ? { ...sx, ...props.style } : sx}
      className={`data-loader ${overlay && 'overlay'} ${fullscreen && 'fullscreen'} logo-spinner-preloader`}>
      {logo && <img src={props.dark ? logo.miniDark : logo.mini} alt={title} />}
      {(props.title && props.title.length > 0) && <h1 className='title'>{title}</h1>}
    </div>
  );
}
